import request from '@/utils/request'
import { getRequest } from "@/utils/postData";
// 登录（用户密码）
export function getlogin(data) {
    var sign = getRequest(data);
    return request({
        url: '/v4/users/pwd_sign_in',
        method: 'post',
        data,
        headers: {
            'X-Signature': sign
        }
    })
}
// 文章详情（免费单行本,付费，普通，杂志）
export function getFreeArticleDetail(id) {
    var sign = getRequest({});
    return request({
        url: `v4/articles/${id}`,
        method: 'get',
        headers: {
            'X-Signature': sign,
            'ClientVersion': '4.0.0',
            'ClientPlatform': 'PC'
        }
    })
}
// 文章评论
export function getArticleComment(id, params) {
    var sign = getRequest(params);
    return request({
        url: `v4/articles/${id}/comments`,
        method: 'get',
        params,
        headers: {
            'X-Signature': sign
        }
    })
}
// 相关文章
export function getAboutArticle(id) {
    var sign = getRequest({});
    return request({
        url: `v4/articles/${id}/recommendations`,
        method: 'get',
        headers: {
            'X-Signature': sign
        }
    })
}

// 文章精选评论
export function getArticleCommentCull(id) {
    var sign = getRequest({});
    return request({
        url: `v4/articles/${id}/best_comments`,
        method: 'get',
        headers: {
            'X-Signature': sign
        }
    })
}
// 关于作者列表
export function getAuthorList(params) {
    var sign = getRequest(params);
    return request({
        url: 'v4/authors',
        method: 'get',
        params: {
            page: params.page,
            per: params.per
        },
        headers: {
            'X-Signature': sign
        }
    })
}
// 关注作者接口
export function getAttention(id) {
    var sign = getRequest({});
    return request({
        url: `/v4/authors/${id}/follow`,
        method: 'post',
        headers: {
            'X-Signature': sign
        }
    })
}
// 取消关注作者接口
export function getCancelAttention(id) {
    var sign = getRequest({});
    return request({
        url: `/v4/authors/${id}/follow`,
        method: 'delete',
        headers: {
            'X-Signature': sign
        }
    })
}
// 取消关注(杂志)
export function getCancelColumn(id) {
    var sign = getRequest({});
    return request({
        url: `v4/columns/${id}/follow`,
        method: 'delete',
        headers: {
            'X-Signature': sign
        }
    })
}
// 关注（杂志）
export function getMangzineColumn(id) {
    var sign = getRequest({});
    return request({
        url: `v4/columns/${id}/follow`,
        method: 'post',
        headers: {
            'X-Signature': sign
        }
    })
}
// 取消关注(标签)
export function getCancelLaber(id) {
    var sign = getRequest({});
    return request({
        url: `/v4/topics/${id}/follow`,
        method: 'delete',
        headers: {
            'X-Signature': sign
        }
    })
}
// 关注（标签）
export function getTopicsLaber(id) {
    var sign = getRequest(id);
    return request({
        url: `/v4/topics/${id}/follow`,
        method: 'post',
        headers: {
            'X-Signature': sign
        }
    })
}
// 评论点赞
export function getCommentLike(id) {
    var sign = getRequest({});
    return request({
        url: `v4/comments/${id}/like`,
        method: 'post',
        headers: {
            'X-Signature': sign
        }
    })
}
// 文章点赞
export function getArctileLike(id) {
    var sign = getRequest({});
    return request({
        url: `v4/articles/${id}/very_like`,
        method: 'post',
        headers: {
            'X-Signature': sign
        }
    })
}
// 文章喜欢/取消喜欢接口
export function getLike(id) {
    var sign = getRequest({});
    return request({
        url: `v4/articles/${id}/like`,
        method: 'post',
        headers: {
            'X-Signature': sign
        }
    })
}
// 文章收藏，取消收藏接口
export function getCollection(id, type) {
    var sign = getRequest({
        type: type
    })
    return request({
        url: `/v4/articles/${id}/favorite`,
        method: 'post',
        params: {
            type: type
        },
        headers: {
            'X-Signature': sign
        }
    })
}
// 文章发表评论
export function getPublishComment(id, data) {
    var sign = getRequest(data)
    return request({
        url: `/v4/articles/${id}/comments`,
        method: 'post',
        data: data,
        headers: {
            'X-Signature': sign
        }
    })
}
// 文章-作者-作者详情
export function getArthorDetail(id) {
    var sign = getRequest(id);
    return request({
        url: `/v4/authors/${id}`,
        method: 'get',
        headers: {
            'X-Signature': sign
        }
    })
}
// 文章-作者-某作者发布的文章列表接口
export function getAuthorArticleList(id, params) {
    var sign = getRequest(params);
    return request({
        url: `/v4/authors/${id}/articles`,
        method: 'get',
        params,
        headers: {
            'X-Signature': sign
        }
    })
}
// 获取用户信息
export function getUserInfo(id) {
    var sign = getRequest({});
    return request({
        url: '/v4/users/me',
        method: 'get',
        headers: {
            'X-Signature': sign
        }
    })
}
// 文章-去投票接口/v4/articles/{id}/votes
export function getVotes(data, id) {
    var sign = getRequest(data);
    return request({
        url: `/v4/articles/${id}/votes`,
        method: 'post',
        data,
        headers: {
            'X-Signature': sign
        }
    })
}
// 用户-获取连接七牛所需凭证接口
export function getVoucher() {
    var sign = getRequest({});
    return request({
        url: '/v4/services/uptoken',
        method: 'get',
        headers: {
            'X-Signature': sign
        }
    })
}
// 用户-七牛云-上传用户头像接口
export function getUserImage(data) {
    var sign = getRequest(data);
    return request({
        url: '/v1',
        method: 'post',
        data,
        headers: {
            'X-Signature': sign,
            // "Content-Type": 'multipart/form-data',
        }
    })
}
// 用户修改手机号前发送验证码
export function getResetPhoneCode(data) {
    var sign = getRequest(data);
    return request({
        url: '/v4/yicai_users/reset_phone_sms',
        method: 'post',
        data,
        headers: {
            'X-Signature': sign
        }
    })
}
// 用户修改手机号
export function getResetPhone(data) {
    var sign = getRequest(data);
    return request({
        url: '/v4/users/reset_login_name',
        method: 'post',
        data,
        headers: {
            'X-Signature': sign
        }
    })
}



// WEBPACK FOOTER //
// ./src/api/public.js